/**
 * Обновляет поля объектов (бригады или УИППС) на основе массива маркеров.
 *
 * @param {Array<Object>} items - Список объектов из состояния (например, список бригад или УИППС).
 * @param {Array<Object>} markers - Массив маркеров с координатами, датой и статусами.
 *
 * @returns {Array<Object>} - Новый массив с обновлёнными полями из соответствующих маркеров.
 *
 * Обновляемые поля:
 *   - Общие: date, lat, lon
 *   - Для Бригад: status, start, finish
 *   - Для УИППС: online
 */
export function mergeData(items, markers) {
  // Проверка: если входные параметры не массивы, возвращаем пустой массив
  if (!Array.isArray(items) || !Array.isArray(markers)) return [];

  // Создаём Map для быстрого доступа к маркерам по id
  const markerMap = new Map(markers.map((m) => [String(m.id), m]));

  // Обновляем каждый элемент из items
  return items.map((item) => {
    // Находим соответствующий маркер по id
    const marker = markerMap.get(String(item.id));

    // Если маркер не найден — возвращаем элемент без изменений
    if (!marker) return item;

    // Создаём новый объект с обновлёнными полями
    const updated = {
      ...item,
      date: marker.date || null,
      lat: marker.position?.[0] ?? null,
      lon: marker.position?.[1] ?? null,
    };

    // Если это бригада — обновляем доп. поля
    if (marker.type === 'Бригада') {
      updated.status = marker.status;
      updated.start = marker.start || null;
      updated.finish = marker.finish || null;
    }

    // Если это УИППС — обновляем статус онлайн
    else if (marker.type === 'УИППС') {
      updated.online = marker.online;
    }

    return updated;
  });
}
